<template>
  <expandable header="Media Consent" class="mb-10">
    <b-row>
      <b-col cols="12" md="4">
        <radio-group
          v-model.trim="form.media_consent_given"
          label="Media Consent Given"
          :options="consentOptions"
          :disabled="isDisabled"
          @input="onInput"
          rules="required"
        ></radio-group>
      </b-col>
      <b-col cols="12" md="8" v-if="form.media_consent_given == '1'">
        <text-area
          v-model.trim="form.media_consent_details"
          label="Media Consent Details"
          :disabled="isDisabled"
          @input="onInput"
          rules="required|max-500"
        ></text-area>
      </b-col>
      <b-col cols="12" md="4" v-if="form.media_consent_given == '1'">
        <input-field
          v-model.trim="form.media_contact_person"
          label="Media Contact Person"
          :disabled="isDisabled"
          @input="onInput"
          rules="max-100"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4" v-if="form.media_consent_given == '1'">
        <phone-field
          v-model.trim="form.media_contact_number"
          label="Media Contact Number"
          :disabled="isDisabled"
          @input="onInput"
          rules="integer"
        ></phone-field>
      </b-col>
      <b-col cols="12" md="4" v-if="form.media_consent_given == '1'">
        <file-input-group
          v-model.trim="form.media_consent_document"
          label="Media Consent Document"
          :disabled="isDisabled"
          accept=".jpg,capture=camera,.jpeg,.png,.pdf"
          @input="onInput"
          rules="file-image-pdf|file-size"
        ></file-input-group>
      </b-col>
    </b-row>
  </expandable>
</template>

<script>
import Expandable from "../../Expandable.vue";
import RadioGroup from "../../form/RadioGroup.vue";
import PhoneField from "../../form/PhoneField.vue";
import TextArea from "../../form/TextArea.vue";
import FileInputGroup from "../../form/FileInputGroup.vue";
export default {
  props: {
    value: {},
    isDisabled: {
      default: false,
      type: Boolean,
    },
  },
  components: {
    Expandable,
    RadioGroup,
    PhoneField,
    TextArea,
    FileInputGroup,
  },
  data() {
    return {
      form: {},
      consentOptions: [
        { name: "Yes", value: "1" },
        { name: "No", value: "0" },
      ],
    };
  },
  methods: {
    onInput() {
      this.$emit("input", this.form);
    },
  },
  beforeMount() {
    this.form = this.value;
  },
};
</script>

<style></style>
